import logoImg from "@/assets/logo.png";

const LOGO_URL = logoImg;

export default function Logo({ size = 56, withWordmark = true, className = "" }) {
    return (
        <div
            className={`inline-flex items-center gap-3 ${className}`}
            data-testid="matrona-logo"
        >
            <img
                src={LOGO_URL}
                alt="Matrona IA"
                width={size}
                height={size}
                className="rounded-xl"
                style={{ width: size, height: size, objectFit: "contain" }}
                loading="eager"
            />
            {withWordmark && (
                <span
                    className="headline text-[1.35rem] sm:text-[1.55rem] tracking-tight"
                    style={{ color: "var(--color-ink)" }}
                >
                    Matrona IA
                </span>
            )}
        </div>
    );
}
